/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DebitingDetailsDto } from '../../models/debiting-details-dto';
import { DebitingDetailsRequest } from '../../models/debiting-details-request';

export interface UpdateDebitingDetails$Params {

/**
 * id of the debit details to update
 */
  id: number;
      body: DebitingDetailsRequest
}

export function updateDebitingDetails(http: HttpClient, rootUrl: string, params: UpdateDebitingDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<DebitingDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, updateDebitingDetails.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DebitingDetailsDto>;
    })
  );
}

updateDebitingDetails.PATH = '/debitingDetails/{id}';
